import {
  NB_BEHAVIOUR_INTRO_PARAGRAPHS,
  NB_BEHAVIOUR_TYPES,
} from 'affiny-core/helpers/personalityReport';
import { useTitlePosition } from 'affiny-desktop/src/hooks';
import { Box, rem, ShadowBox } from 'affiny-ui/src';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { PersonalityReportLayerParagraph } from './PersonalityReportLayerParagraph';
import { PersonalityReportLayerTitle } from './PersonalityReportLayerTitle';

interface IPersonalityReportLayerPersonalityBehevior {
  setTitle: (title: string) => void;
}

export const PersonalityReportLayerPersonalityBehevior = ({
  setTitle,
}: IPersonalityReportLayerPersonalityBehevior) => {
  const { t } = useTranslation();
  const titleRef = useRef<HTMLDivElement>(null);

  useTitlePosition({ setTitle, title: 'behaviourProfile', titleRef });

  return (
    <Box mb="xLarge" pb="xLarge">
      <div ref={titleRef}>
        <PersonalityReportLayerTitle isPrimary id={'behaviourProfile'}>
          {t(`personalityReport.personality.behaviourProfile.title`)}
        </PersonalityReportLayerTitle>
      </div>

      {[...Array(NB_BEHAVIOUR_INTRO_PARAGRAPHS).keys()].map((key, idx) => (
        <PersonalityReportLayerParagraph key={idx}>
          {t(`personalityReport.personality.behaviourProfile.intro.${key}`)}
        </PersonalityReportLayerParagraph>
      ))}

      <PersonalityReportLayerTitle>
        {t(`personalityReport.personality.behaviourProfile.subtitle`)}
      </PersonalityReportLayerTitle>

      <ShadowBox width={rem(544)} p="xLarge" m="auto" mb="xLarge">
        {[...Array(NB_BEHAVIOUR_TYPES).keys()].map((key, idx) => (
          <React.Fragment key={idx}>
            <PersonalityReportLayerTitle isPrimary textAlign="center">
              {t(
                `personalityReport.personality.behaviourProfile.types.${key}.title`
              )}
            </PersonalityReportLayerTitle>

            <PersonalityReportLayerParagraph style={{ textAlign: 'center' }}>
              {t(
                `personalityReport.personality.behaviourProfile.types.${key}.description`
              )}
            </PersonalityReportLayerParagraph>
          </React.Fragment>
        ))}
      </ShadowBox>

      <PersonalityReportLayerParagraph>
        {t(`personalityReport.personality.behaviourProfile.outro`)}
      </PersonalityReportLayerParagraph>
    </Box>
  );
};
